export const PAYMENT_INSTRUCTIONS = {
  BRI: [
    {
      title: "BRImo",
      content: [
        "Login ke aplikasi BRImo.",
        "Pilih menu Pembayaran > BRIVA.",
        "Masukkan nomor Virtual Account.",
        "Konfirmasi detail tagihan.",
        "Masukkan PIN BRImo, lalu kirim.",
        "Bukti pembayaran akan muncul/notifikasi SMS.",
      ],
    },
    {
      title: "Internet Banking BRI",
      content: [
        "Login ke Internet Banking BRI.",
        "Pilih menu Pembayaran > BRIVA.",
        "Pilih rekening sumber, masukkan nomor VA.",
        "Konfirmasi detail transaksi.",
        "Masukkan nominal, lanjutkan.",
        "Masukkan password/m-PIN, kirim.",
        "Simpan bukti transaksi.",
      ],
    },
    {
      title: "ATM BRI",
      content: [
        "Masukkan kartu & PIN.",
        "Pilih Transaksi Lain > Pembayaran > Lainnya > BRIVA.",
        "Masukkan nomor VA.",
        "Konfirmasi data, pilih YA/BENAR.",
        "Simpan struk pembayaran.",
      ],
    },
  ],
  BNI: [
    {
      title: "BNI Mobile",
      content: [
        "Login ke aplikasi BNI Mobile.",
        "Pilih menu Transfer > Virtual Account Billing.",
        "Pilih rekening debet.",
        "Masukkan nomor VA.",
        "Konfirmasi tagihan, masukkan password transaksi.",
        "Transaksi selesai.",
      ],
    },
    {
      title: "Internet Banking BNI",
      content: [
        "Login ke ibank.bni.co.id.",
        "Pilih menu Transfer > Virtual Account Billing.",
        "Masukkan nomor VA, pilih rekening debet.",
        "Konfirmasi tagihan, masukkan token.",
        "Transaksi selesai.",
      ],
    },
    {
      title: "ATM BNI",
      content: [
        "Masukkan kartu & PIN.",
        "Pilih Menu Lainnya > Transfer > Virtual Account Billing.",
        "Masukkan nomor VA.",
        "Konfirmasi tagihan, lanjutkan transaksi.",
        "Simpan bukti transfer.",
      ],
    },
  ],
  BSI: [
    {
      title: "BSI Mobile",
      content: [
        "Login ke aplikasi BSI Mobile.",
        "Pilih menu Transfer > Virtual Account Billing.",
        "Pilih rekening debet.",
        "Masukkan nomor VA.",
        "Konfirmasi tagihan, masukkan PIN.",
        "Tekan Selanjutnya untuk menyelesaikan transaksi.",
      ],
    },
    {
      title: "Internet Banking BSI",
      content: [
        "Login ke Internet Banking BSI.",
        "Pilih menu Pembayaran > Virtual Account.",
        "Masukkan kode institusi (misal: 1062) dan nomor VA.",
        "Konfirmasi data, masukkan PIN/token.",
        "Transaksi selesai.",
      ],
    },
    {
      title: "ATM BSI",
      content: [
        "Masukkan kartu & PIN.",
        "Pilih Menu Lainnya > Transfer > Virtual Account Billing.",
        "Masukkan nomor VA.",
        "Konfirmasi tagihan, lanjutkan transaksi.",
        "Simpan bukti pembayaran.",
      ],
    },
  ],
  CIMB: [
    {
      title: "OCTO Mobile",
      content: [
        "Login ke aplikasi OCTO Mobile.",
        "Pilih menu Transfer > Transfer ke Rekening CIMB Lainnya.",
        "Masukkan nomor VA.",
        "Masukkan nominal pembayaran.",
        "Konfirmasi, masukkan PIN.",
        "Selesai, bukti bayar dikirim via SMS.",
      ],
    },
    {
      title: "OCTO Clicks",
      content: [
        "Login ke OCTO Clicks.",
        "Pilih menu Bayar Tagihan/Pay Bills.",
        "Pilih rekening sumber, jenis pembayaran Virtual Account.",
        "Masukkan nomor VA.",
        "Konfirmasi, masukkan mPIN.",
        "Selesai.",
      ],
    },
    {
      title: "ATM CIMB Niaga",
      content: [
        "Masukkan kartu & PIN.",
        "Pilih Pembayaran > Lanjut > Virtual Account.",
        "Masukkan nomor VA.",
        "Pilih rekening debit, konfirmasi data.",
        "Pilih OK, ambil bukti transaksi.",
      ],
    },
    {
      title: "ATM Bersama / Prima / Lainnya",
      content: [
        'Pilih menu "Transfer" -> "Transfer ke Bank Lain".',
        "Masukkan Kode Bank CIMB Niaga (022).",
        "Masukkan Nomor Virtual Account tujuan.",
        "Masukkan Nominal Pembayaran sesuai tagihan.",
        "Ikuti instruksi untuk konfirmasi transaksi dan simpan struk.",
      ],
    },
    {
      title: "Mobile Banking / Internet Banking Bank Lain",
      content: [
        'Pilih menu "Transfer" -> "Transfer Antar Bank" atau "Transfer Online".',
        'Pilih bank tujuan "CIMB Niaga (022)".',
        "Masukkan Nomor Virtual Account tujuan.",
        "Masukkan Nominal Pembayaran.",
        "Konfirmasi detail transaksi.",
      ],
    },
  ],
  BCA: [
    {
      title: "BCA Mobile",
      content: [
        "Login ke aplikasi BCA Mobile.",
        "Pilih menu m-Transfer > BCA Virtual Account.",
        "Masukkan nomor VA, klik Send.",
        "Cek detail transaksi, masukkan PIN m-BCA.",
        "Transaksi selesai.",
      ],
    },
    {
      title: "KlikBCA",
      content: [
        "Login ke KlikBCA.",
        "Pilih Transfer Dana > Transfer ke BCA Virtual Account.",
        "Masukkan nomor VA, klik Lanjutkan.",
        "Masukkan respon KeyBCA, klik Kirim.",
        "Transaksi selesai.",
      ],
    },
    {
      title: "ATM BCA",
      content: [
        "Masukkan kartu & PIN.",
        "Pilih Transaksi Lainnya > Transfer > Ke Rek BCA Virtual Account.",
        "Masukkan nomor VA, klik Benar.",
        "Cek detail, pilih Ya.",
        "Simpan struk.",
      ],
    },
  ],
  MANDIRI: [
    {
      title: "Livin' by Mandiri",
      content: [
        "Login ke aplikasi Livin’ by Mandiri.",
        "Pilih menu Bayar/VA di halaman beranda.",
        "Masukkan nomor VA di kolom pencarian.",
        "Pilih penyedia jasa, masukkan nominal pembayaran.",
        "Konfirmasi, masukkan PIN Livin’.",
        "Transaksi selesai.",
      ],
    },
    {
      title: "Internet Banking Mandiri",
      content: [
        "Login ke Mandiri Online.",
        "Pilih Pembayaran > Multi Payment.",
        "Pilih penyedia jasa, masukkan nomor VA.",
        "Konfirmasi tagihan, masukkan PIN.",
        "Simpan bukti transaksi.",
      ],
    },
    {
      title: "ATM Mandiri",
      content: [
        "Masukkan kartu & PIN.",
        "Pilih Bayar/Beli > Multi Payment.",
        "Masukkan kode perusahaan, lalu nomor VA.",
        "Masukkan nominal pembayaran.",
        "Konfirmasi, pilih Ya.",
        "Simpan struk.",
      ],
    },
  ],
  BTPN: [
    {
      title: "Jenius App",
      content: [
        "Buka menu 'Send It'.",
        "Klik 'Tambah Penerima'.",
        "Pilih bank tujuan 'BTPN'.",
        "Masukkan nomor rekening virtual di atas dan klik 'Lanjut'.",
        "Masukkan jumlah nominal di atas.",
        "Ikuti petunjuk hingga transaksi selesai.",
      ],
    },
    {
      title: "ATM BTPN",
      content: [
        "Masukkan kartu debit/ATM Anda.",
        "Masukkan PIN Anda.",
        "Pilih 'Menu Lain'.",
        "Pilih 'Transfer'.",
        "Pilih 'Rekening Nasabah Lain di BTPN'.",
        "Input nomor VA sebagai nomor rekening tujuan.",
        "Periksa detil transaksi pada layar ATM.",
        "Jika sudah sesuai, konfirmasi transaksi Anda.",
        "Jika transaksi berhasil, Anda akan melihat tampilan 'Transaksi berhasil' pada layar ATM Anda.",
      ],
    },
    {
      title: "Phone (Khusus nasabah BTPN WOW!)",
      content: [
        "Telepon *247#.",
        "Masukkan PIN BTPN Wow! Anda dan kirim.",
        "Ketik 99 (untuk ke Menu Utama) dan kirim.",
        "Ketik 4 (untuk ke menu Kirim Uang) dan kirim.",
        "Ketik 4 (untuk ke menu Rekening Virtual) dan kirim.",
        "Masukkan nomor tujuan rekening virtual dan kirim.",
        "Masukkan jumlah pengiriman uang dan kirim.",
        "Ketik PIN BTPN Wow! untuk konfirmasi transaksi.",
        "Anda akan menerima notifikasi transaksi berhasil.",
      ],
    },
    {
      title: "Tunai via Agen (Khusus nasabah BTPN WOW!)",
      content: [
        "Kunjungi Agen BTPN Wow! terdekat dengan membawa uang tunai yang akan dikirimkan.",
        "Informasikan nomor rekening virtual tujuan dan nominal yang akan dikirimkan ke Agen BTPN Wow!.",
        "Serahkan uang tunai ke Agen BTPN Wow!.",
        "Agen BTPN Wow! akan memproses transaksi Anda melalui aplikasi/sistem agen BTPN Wow!.",
      ],
    },
  ],
  DANAMON: [
    {
      title: "ATM Bank Danamon menggunakan Kartu Bank Danamon",
      content: [
        "Input kartu ATM dan PIN Anda.",
        "Pilih Menu pembayaran >>> Virtual Account.",
        "Masukkan nomor Virtual Account.",
        "Masukkan nominal.",
        "Pada layar konfirmasi pembayaran, pastikan transaksi sudah benar -> pilih YA untuk memproses transaksi.",
      ],
    },
    {
      title: "Aplikasi D-Mobile",
      content: [
        "Login pada Aplikasi D-Mobile.",
        "Pilih menu Virtual Account.",
        "Masukkan 16 digit nomor virtual account.",
        "Masukkan nominal.",
        "Pada layar konfirmasi pembayaran, pastikan transaksi sudah benar -> pilih Ya untuk memproses transaksi.",
      ],
    },
    {
      title: "ATM Bank Danamon menggunakan Kartu Bank Lain",
      content: [
        "Masuk ke menu transfer.",
        "Pilih tujuan rekening Bank Danamon.",
        "Masukkan Kode Bank Danamon (011) + 16 digit nomor Virtual Account.",
        "Masukkan nominal pembayaran.",
        "Pada layar konfirmasi pembayaran, harap pastikan nama tujuan dan nominal transaksi sudah tepat.",
        "Konfirmasi pembayaran.",
      ],
    },
    {
      title: "ATM Bank lain menggunakan Kartu Bank Danamon atau Bank Lain",
      content: [
        "Masuk ke menu transfer.",
        "Pilih tujuan rekening bank lain (Online Transfer).",
        "Masukkan Kode Bank Danamon (011) + 16 digit nomor Virtual Account.",
        "Masukkan nominal pembayaran.",
        "Pada layar konfirmasi pembayaran, harap pastikan nama tujuan dan nominal transaksi sudah tepat.",
        "Konfirmasi pembayaran.",
      ],
    },
    {
      title:
        "Internet Banking Bank lain, Transfer Online (ATM Bersama / ALTO / Prima)",
      content: [
        "Masuk ke menu transfer ke bank lain.",
        "Pilih transfer online.",
        "Pilih Bank tujuan, Bank Danamon.",
        "Masukkan 16 digit nomor Virtual Account.",
        "Masukkan nominal pembayaran.",
        "Pada layar konfirmasi pembayaran, harap pastikan nama tujuan dan nominal transaksi sudah tepat.",
        "Konfirmasi pembayaran.",
      ],
    },
  ],
  PERMATA: [
    {
      title: "ATM",
      content: [
        "Masukkan kartu ATM Permata Anda.",
        "Masukkan PIN.",
        "Pilih menu 'Transaksi Lainnya'.",
        "Pilih menu 'Pembayaran'.",
        "Pilih menu 'Pembayaran Lainnya'.",
        "Pilih menu 'Virtual Account'.",
        "Masukkan Nomor Virtual Account 8214XXXXXXXXXXXXXXXX.",
        "Pilih rekening debet yang akan digunakan.",
        "Konfirmasi detail transaksi Anda (contoh: Rekening tabungan).",
        "Transaksi Anda telah selesai.",
      ],
    },
    {
      title: "Mobile Banking",
      content: [
        "Buka aplikasi PermataMobile Internet.",
        "Masukkan User ID dan Password.",
        "Pilih 'Bayar Tagihan'.",
        "Pilih 'Virtual Account'.",
        "Masukkan Nomor Virtual Account Anda 8214XXXXXXXXXXXXXXXX.",
        "Masukkan otentikasi transaksi / token.",
        "Transaksi Anda telah selesai.",
      ],
    },
    {
      title: "Internet Banking",
      content: [
        "Buka situs https://new.permatanet.com.",
        "Masukkan User ID dan Password.",
        "Pilih 'Pembayaran Tagihan'.",
        "Pilih 'Virtual Account'.",
        "Masukkan Nomor Virtual Account 8214XXXXXXXXXXXXXXXX.",
        "Periksa kembali detail pembayaran Anda.",
        "Masukkan otentikasi transaksi/token.",
        "Transaksi Anda telah selesai.",
      ],
    },
    {
      title: "Dari Rekening Bank Lain ke Virtual Account Permata",
      content: [
        "Masukkan User ID dan Password.",
        "Pilih 'Transfer'.",
        "Pilih 'ke rek. Bank lain'.",
        "Pilih 'Bank tujuan'.",
        "Masukkan nomor Virtual Account Anda (Permata 8214XXXXXXXXXXXXXXXX).",
        "Input nominal yang ditagihkan sebagai nominal transfer.",
        "Selesai, transaksi berhasil.",
      ],
    },
  ],
};
